module.exports = __webpack_public_path__ + "media/images/bg-modal-basic-header-a83d8b71379a7659bb63bb8576029162.png";